<template>
    <InformeCard title="Desglose por categoría">
        <GChart
            type="PieChart"
            :data="chartData"
            :options="chartOptions"
        />
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['valores'],
        data() {
            return {
                loading: false,
                chartOptions: {
                    height: 364,
                    chartArea:{width:'100%'},
                    pieHole: 0.4
                }
            }
        },
        computed: {
            chartData() {
                var data = null;
                if(this.valores) {
                    data = this.valores;
                } else {
                    data = null;
                }

                return data;
            }
        },
        components: {
            InformeCard,
        }
    }
</script>
